import { useEffect, useState } from "react";
import { IStringLocalizer } from "../../../utilities/IStringLocalizer";
import CheckBox from "../CheckBox";
import DateInput from "../DateInput";

interface ComplianceResponseDateProps {
    value: string;
    onValueChange: (value: string) => void;
    localizer: IStringLocalizer;
    isDisabled?: boolean;
}

const ComplianceResponseDate: React.FC<ComplianceResponseDateProps> = ({ value, onValueChange, localizer, isDisabled }) => {
    const current = "current";
    const unknown = "unknown";
    const today = new Date().toISOString().split("T")[0];
    const [complianceResponseDate, setComplianceResponseDate] = useState(value === current || value === '' ? today : value);
    const [isCurrentSelected, setIsCurrentSelected] = useState(value === current || complianceResponseDate === today);

    const onCheckboxChanged = (selected: boolean) => {
        setIsCurrentSelected(selected);
        if (selected) {
            setComplianceResponseDate(today);
            onValueChange(today);
        } else {
            onValueChange(unknown);
        }
    };

    const onResponseChanged = (value: string) => {
        setComplianceResponseDate(value);
        if (!isCurrentSelected) {
            onValueChange(value);
        }
        if (value === today && !isCurrentSelected) {
            setIsCurrentSelected(true);
            onValueChange(today);
        }
    };

    useEffect(() => {
        if (value === current || value === today) {
            setIsCurrentSelected(true);
            setComplianceResponseDate(today);
        } else if (value && value !== unknown) {
            setIsCurrentSelected(false);
            setComplianceResponseDate(value);
        }
    }, [value]);

    return <>
        <CheckBox
            checkboxLabelText={localizer.localizeString("Current")}
            checked={isCurrentSelected}
            onValueChange={onCheckboxChanged}
            isDisabled={isDisabled}
        />

        <DateInput
            value={complianceResponseDate}
            onValueChange={onResponseChanged}
            disabled={isCurrentSelected}
            isCurrentSelected={isCurrentSelected}
        />
    </>;
};

export default ComplianceResponseDate;